export function replaceElementWithClone(el)
{
    const elClone = el.cloneNode(true);
    el.parentNode.replaceChild(elClone, el);
    return elClone;
}

export function uuid()
{
    //http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
    var d = new Date().getTime();
    if (window.performance && typeof window.performance.now === "function")
    {
        d += performance.now(); //use high-precision timer if available
    }
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c)
    {
        var r = (d + Math.random()*16)%16 | 0;
        d = Math.floor(d/16);
        return (c=='x' ? r : (r&0x3|0x8)).toString(16);
    });
    return uuid;
}

export function checkHttpResponseStatus(response) //response should be a Promise!
{
    //console.log('checkHttpResponseStatus', response.status);
    if (response.status >= 200 && response.status < 300)
    {
        return response;
    }
    else
    {
        var error = new Error(response.statusText);
        error.response = response;
        throw error;
    }
}


export function removeElementsBySelector(selector, parent=document.body)
{
    Array.from(parent.querySelectorAll(selector)).forEach(el => { el.parentNode.removeChild(el); });
}

const whatBrowser = (function(){
    var ua= navigator.userAgent, tem,
    M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if(/trident/i.test(M[1])){
        tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
        return {name:'IE',version:(tem[1] || '')};
    }
    if(M[1]=== 'Chrome'){
        tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
        if(tem!= null) return {name:tem[1].replace('OPR', 'Opera'),version:tem[2]};
    }
    M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
    return {name:M[0],version:M[1]};
})();
export { whatBrowser };
